import { ExchButtonStatus } from '@/types/exch-info';
import { CouponActInfoWithGoodsAndState } from '@tencent/wphk-act-base-framework';
import { CouponState, ExchangeState } from '@tencent/wphk-act-base-types';

/** 格式化详情弹窗中按钮状态 */
const formatDetailButtonStatus = (
  exchInfoItem: CouponActInfoWithGoodsAndState,
  extraInfo?: {isLocked?: boolean, isToReceive?: boolean},
) => {
  // 日库存/总库存不足
  const getIsLimit = (exchInfo: CouponActInfoWithGoodsAndState) => [
    ExchangeState.dayLimit, ExchangeState.totalLimit].includes(exchInfo.exchangeState!);
  const getIsToUse = (exchInfo: CouponActInfoWithGoodsAndState) => exchInfo.couponState === CouponState.received;
  const getIsExpired = (exchInfo: CouponActInfoWithGoodsAndState) => exchInfo.couponState === CouponState.expired;
  const getIsToReceive = (exchInfo: CouponActInfoWithGoodsAndState) => {
    const isCouponReceived = [
      CouponState.expired, CouponState.received, CouponState.used].includes(exchInfo.couponState!);
    return !isCouponReceived;
  };
  if (getIsToUse(exchInfoItem)) {
    return ExchButtonStatus.ToUse; // '去使用';
  }
  if (getIsExpired(exchInfoItem)) { // '已过期
    return ExchButtonStatus.Hidden;
  }
  if (extraInfo?.isLocked) {
    return ExchButtonStatus.IsLocked; // '待解鎖';
  }
  if (getIsLimit(exchInfoItem)) {
    return ExchButtonStatus.IsLimit;// '今日已領完';
  }
  if (extraInfo?.isToReceive || getIsToReceive(exchInfoItem)) {
    return ExchButtonStatus.ToReceive;// '立即領取';
  }
  return ExchButtonStatus.Hidden;
};


export const useExchInfo = ({ exchInfo, extraInfo }:
{exchInfo: CouponActInfoWithGoodsAndState, extraInfo?: {isLocked?: boolean, isToReceive?: boolean}}) => ({
  discount: (exchInfo.discount ?? 0) * 100,
  exchButtonStatus: formatDetailButtonStatus(exchInfo, extraInfo),
});
